<div class="navigation">
  <span class="navigation__header">NAVIGATION</span>
  <span
    id="{{tab}}"
    class="navigation__tab"
    *ngFor="let tab of tabs"
    (click)="tabClick(tab)">
    {{tab}}
  </span>
</div>